function PrivacyPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p>Last updated: March 2026</p>
      </div>

      <div className="page-content">
        <h2>Introduction</h2>
        <p>
          Music4Fun LLC ("Company," "we," "us," or "our") operates the Music4Fun applications and services. This page informs you of our policies regarding the collection, use, and disclosure of data when you use our Service and the choices you have associated with that data.
        </p>

        <h2>Information Collection and Use</h2>
        <p>
          We do not collect any personal information from users of our Service. We do not ask for, store, or have access to any personally identifiable information such as your name, email address, phone number, or location data.
        </p>

        <h2>Advertising</h2>
        <p>
          Our Service displays ads provided by third-party advertising networks. These ad networks may collect certain information directly from your device in order to serve relevant advertisements. This may include information such as your device's advertising identifier, IP address, and general usage data.
        </p>
        <p>
          We do not have access to the data collected by these ad networks. Their data collection and use is governed by their own privacy policies. We encourage you to review the privacy policies of our advertising partners for more information on how they handle your data.
        </p>

        <h2>Usage Data</h2>
        <p>
          We may collect limited, non-personal diagnostic information about how the Service is accessed and used ("Usage Data"), such as crash reports and general performance data. This information does not identify you personally and is used solely to improve the stability and performance of the Service.
        </p>

        <h2>Use of Data</h2>
        <p>
          Music4Fun LLC uses the limited data available to us for the following purposes:
        </p>
        <ul>
          <li>To provide and maintain our Service</li>
          <li>To notify you about changes to our Service</li>
          <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>To provide customer care and support</li>
          <li>To gather analysis or valuable information so that we can improve our Service</li>
          <li>To monitor the usage of our Service</li>
          <li>To detect, prevent and address technical issues</li>
        </ul>

        <h2>Security of Data</h2>
        <p>
          The security of your data is important to us. Since we do not collect personal information, your privacy exposure through our Service is minimal. However, please be aware that third-party ad networks operate independently and you should review their security practices separately.
        </p>

        <h2>Third-Party Service Providers</h2>
        <p>
          We may employ third-party companies and individuals to facilitate our Service ("Service Providers"), such as advertising networks. These third parties operate under their own privacy policies and we do not have access to any personal data they may collect. They are obligated by their own terms not to disclose or misuse such information.
        </p>

        <h2>Links to Other Sites</h2>
        <p>
          Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
        </p>

        <h2>Children's Privacy</h2>
        <p>
          Our Service does not address anyone under the age of 13 ("Children"). We do not knowingly collect personally identifiable information from children under 13. Since we do not collect personal data directly, there is no risk of us inadvertently storing children's information. If you have concerns about data collected by third-party ad networks regarding children, please contact those networks directly or contact us at the information below.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <ul>
          <li>Email: contact@music4fun.net</li>
          <li>Address: 5900 Balcones Drive STE 100, Austin, TX 78731</li>
        </ul>

        <h2>Your Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding any data held about you by third-party services used within our app. Since we do not collect personal data directly, requests related to data access, deletion, or portability should be directed to the relevant third-party ad networks. However, you may still contact us and we will do our best to assist:
        </p>
        <ul>
          <li>The right to access, update or delete the information we have on you</li>
          <li>The right to rectification of inaccurate data</li>
          <li>The right to object to processing of your data</li>
          <li>The right to restrict processing of your data</li>
          <li>The right to data portability</li>
          <li>The right to withdraw consent</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at the information provided above.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPage;